import * as React from "react"

import { cn } from "@/lib/utils"

/** Shared textarea primitive matching Input token chrome; accepts native textarea props. */
function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground",
        "border-2 border-input bg-background min-h-16 w-full min-w-0 rounded-md px-3 py-2 text-base",
        "transition-all duration-150 ease-out",
        "shadow-sm",
        "outline-none",
        "focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/20 focus-visible:shadow-md",
        "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-muted",
        "aria-invalid:border-destructive aria-invalid:ring-destructive/20",
        "md:text-sm",
        className
      )}
      {...props}
    />
  )
}

export { Textarea }
